<template>
  <!-- Service Section -->
  <section class="car-service-section common-padding">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-3 col-md-4 col-sm-6 aos" data-aos="flip-up">
          <div class="car-service-container">
            <img src="@/assets/img/icons/bx-wrench.svg" alt="" />
            <h4>Auto Repair</h4>
            <p>We buy and sale barand new car and also used car of any brand</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-6 aos" data-aos="flip-down">
          <div class="car-service-container">
            <img src="@/assets/img/icons/bx-map-pin.svg" alt="" />
            <h4>Rental Service</h4>
            <p>We buy and sale barand new car and also used car of any brand</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-6 aos" data-aos="flip-up">
          <div class="car-service-container">
            <img src="@/assets/img/icons/bx-pie-chart.svg" alt="" />
            <h4>Tire Change</h4>
            <p>We buy and sale barand new car and also used car of any brand</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-6 aos" data-aos="flip-up">
          <div class="car-service-container">
            <img src="@/assets/img/icons/bx-planet.svg" alt="" />
            <h4>Official Dealers</h4>
            <p>We buy and sale barand new car and also used car of any brand</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-6 aos" data-aos="flip-up">
          <div class="car-service-container">
            <img src="@/assets/img/icons/bx-gift.svg" alt="" />
            <h4>Paint Work</h4>
            <p>We buy and sale barand new car and also used car of any brand</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-6 aos" data-aos="flip-down">
          <div class="car-service-container">
            <img src="@/assets/img/icons/bx-power-off.svg" alt="" />
            <h4>Car Diagonostics</h4>
            <p>We buy and sale barand new car and also used car of any brand</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-6 aos" data-aos="flip-up">
          <div class="car-service-container">
            <img src="@/assets/img/icons/bx-trophy.svg" alt="" />
            <h4>Battery Replacements</h4>
            <p>We buy and sale barand new car and also used car of any brand</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-6 aos" data-aos="flip-down">
          <div class="car-service-container">
            <img src="@/assets/img/icons/bx-repost.svg" alt="" />
            <h4>Dry Cleaning Car</h4>
            <p>We buy and sale barand new car and also used car of any brand</p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Service Section -->

  <!-- Our Team -->
  <section class="our-team-car common-padding">
    <div class="container">
      <div class="row aos" data-aos="fade-up">
        <div class="col-lg-12">
          <div class="home-six-heading-section">
            <div
              class="home-six-title d-flex justify-content-center align-items-center"
            >
              <h2>Our Team</h2>
              <img src="@/assets/img/icons/title.svg" alt="" />
            </div>
            <p>
              Rutrum ante tempus mauris facilisi, leo faucibus, egestas
              diamlorem malesu, vitae mauris.
            </p>
          </div>
        </div>
      </div>
      <div
        class="car-class-carousel aos"
        data-aos="fade-up"
        data-aos-delay="200"
      >
        <div class="our-team-car-slider owl-carousel owl-theme">
          <Carousel
            :wrap-around="true"
            :settings="settings"
            :breakpoints="breakpoints"
          >
            <Slide v-for="item in IndexSixService" :key="item.id">
              <div class="our-team-block">
                <div class="our-team-img">
                  <router-link to="profile"
                    ><img
                      :src="require(`@/assets/img/business/${item.image}`)"
                      class="img-fluid"
                      alt=""
                  /></router-link>
                </div>
                <div class="our-team-bottom">
                  <router-link to="profile"
                    ><h4>{{ item.title }}</h4></router-link
                  >
                  <p>{{ item.text }}</p>
                </div>
              </div>
            </Slide>
            <template #addons>
              <Pagination />
            </template>
          </Carousel>
        </div>
      </div>
    </div>
  </section>
  <!-- /Our Team -->
</template>

<script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import IndexSixService from "@/assets/json/indexSixService.json";
export default {
  data() {
    return {
      IndexSixService: IndexSixService,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },

      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 700px and up
        767: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        // 991 and up
        991: {
          itemsToShow: 3,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 3,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  mouted() {},
};
</script>
